<div *ngIf="hasThemes" class="sa-taxonomy-preview">
  <h4 class="sa-taxonomy-preview__title">{{ title }}</h4>
  <p *ngIf="showMode && taxonomy?.mode" class="sa-taxonomy-preview__meta">
    Mode: <code>{{ taxonomy?.mode }}</code> — {{ themes.length }} theme(s)
  </p>
  <ul class="sa-taxonomy-theme-list">
    <li *ngFor="let theme of themes; trackBy: trackTheme" class="sa-taxonomy-theme">
      <div class="sa-taxonomy-theme-name">{{ theme.name }}</div>
      <p *ngIf="theme.description" class="sa-taxonomy-desc">{{ theme.description }}</p>
      <p *ngIf="taxonomyKeywordsLabel(theme)" class="sa-taxonomy-kw">
        <span class="sa-taxonomy-kw-label">Keywords:</span> {{ taxonomyKeywordsLabel(theme) }}
      </p>
      <ul *ngIf="theme.subthemes?.length" class="sa-taxonomy-sub-list">
        <li *ngFor="let st of theme.subthemes; trackBy: trackSubtheme" class="sa-taxonomy-sub">
          <span class="sa-taxonomy-sub-name">{{ st.name }}</span>
          <span *ngIf="st.description" class="sa-taxonomy-sub-desc">{{ st.description }}</span>
          <span *ngIf="subthemeKeywordsLabel(st.keywords)" class="sa-taxonomy-sub-kw">
            Keywords: {{ subthemeKeywordsLabel(st.keywords) }}
          </span>
        </li>
      </ul>
    </li>
  </ul>
</div>
